export interface IMUser {
  fid: number;
  nickName: string;
  phone: string;
  zone: string,
  fastkey: string;
  firstname: string;
  lastname: string;
  avatar: string;
  uid: number;
  usertype: number;
  customerId: number;
  token: string;
  socketIp: string[];
  socketPort: number[];
  sign: string;
  identifier: string;
  fname: string;
  email: string;
}

export interface IMUserModel {
  ret: number;
  user: User;
  server: Server[];
  shareurl: Shareurl;
  pushurl: Pushurl;
  fastkey: string;
  downurlcode: string;
  checking: number;
}

export interface Pushurl {
  pushurl: string;
}

export interface Server {
  svrip: string;
  websvrport: number;
}

export interface Shareurl {
  downurl: string;
}

export interface User {
  uid: number;
  nickname: string;
  phonenum: string;
  headurl: string;
  coin: number;
  shopcoin: number;
  freezecoin: number;
  regtime: number;
  lastlogintime: number;
  lastlogouttime: number;
  sign: string;
  region: string;
  qrcode: string;
  siteid: number;
  usertype: number;
  fid: number;
  zone: string;
  fname: string;
  channel: number;
  thirduid: number;
  deviceid: string;
  firstname: string;
  lastname: string;
  privacy: number;
  email: string;
}

// Converts JSON strings to/from your types
export class Convert {
  public static toIMUserModel(json: string): IMUserModel {
    return JSON.parse(json);
  }

  public static iMUserModelToJson(value: IMUserModel): string {
    return JSON.stringify(value);
  }
}
